import { render, staticRenderFns } from "./YuerRecord.vue?vue&type=template&id=6281279a&scoped=true"
import script from "./YuerRecord.vue?vue&type=script&lang=js"
export * from "./YuerRecord.vue?vue&type=script&lang=js"
import style0 from "./YuerRecord.vue?vue&type=style&index=0&id=6281279a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6281279a",
  null
  
)

export default component.exports